import React from 'react';
import { Flex } from '@tpr/core';
import styles from './warning.module.scss';
import { WarningCircle } from '@tpr/icons';
export var WarningBox = function (_a) {
    var children = _a.children, cfg = _a.cfg, _b = _a.warningLabel, warningLabel = _b === void 0 ? 'Warning' : _b;
    return (React.createElement(Flex, { cfg: Object.assign({ flexDirection: 'column', p: 4, my: 4 }, cfg), className: styles.warning, role: "alert" },
        React.createElement(Flex, { cfg: { flexDirection: 'row' } },
            React.createElement(WarningCircle, { cfg: { mr: 4 }, ariaLabel: warningLabel }),
            children)));
};
//# sourceMappingURL=warning.js.map